import { ReactNode } from 'react';

export interface IProps {
    status: EStatus;
    onButtonClick?(): void;
    advDomIdDesktop?: string;
    children?: ReactNode;
}

export enum EStatus {
    NOT_FOUND = 404,
    TOO_MANY_REQUESTS = 429,
    GATEWAY_TIMEOUT = 504,
    INTERNAL_SERVER_ERROR = 500,
    NOT_AVAILABLE = 403,
    BAD_BROWSER = 'bad-browser',
    BAD_BROWSER_ATOM = 'bad-browser-atom',
}

export interface ErrorInfo {
    buttonText: string;
    buttonLink: string;
    title: string;
    imageSrc: string;
    metaTitle: string;
    downloadLink: string;
    annotation: ReactNode;
}
